import * as React from 'react';
import UserImage from '../UserImage/index';
import {
	DropTarget,
	DropTargetConnector,
	DropTargetMonitor,
	ConnectDropTarget,
	DropTargetSpec
 } from 'react-dnd';



let boxTarget = {
    canDrop(props) {
        return true;
    },
	drop(props, monitor, component) {
		return (component.props.droppedItem.data);
	}
}

@DropTarget('changeowner', boxTarget, (connect, monitor) => ({
    droppedItem:monitor.getItem(),
    droppedResult:monitor.getDropResult(),
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))
export default class SelectedSponsor extends React.Component {
	constructor(props){
		super(props);
	}

	render(){
		const { canDrop, isOver, connectDropTarget, data } = this.props;
		const isActive = canDrop || isOver;

		if(data){
			return connectDropTarget(
				<div className="dragger_box ui-draggable started" style={{position: 'relative', top: '-10px'} }>
					  <UserImage profileUrl={(data.ProfileImage)? data.ProfileImage: "../images/default_user.png" } className="user-image-position" size="42" profileName={data.DisplayName}/>
					<a href="javascript:void(0);" title={data.DisplayName}>{data.DisplayName}</a>
					<span className="role" title={data.JobTitle}>{data.JobTitle}</span>
					<span className="email" title={data.Email}>{data.Email}</span>
				</div>
			)
		} else {
			return connectDropTarget(
				<div id="drag_img_box" className= {(isActive)? 'drag_img_box ui-droppable ui-state-highlight': 'drag_img_box ui-droppable'}  style={{display: 'block'}}></div>
			)
		}

	}
}